/**
 * Directional orbit right (clockwise) gesture
 * @module gestures/transforms/orbitRight
 */
import { createOrbitGesture } from './orbitFactory.js';
export default createOrbitGesture('right');
